import { ISelectOption } from '@aon/aon-tws-common-ui';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { TFetchableEntity } from '../models/IFetchableEntity';
import * as HierarchyAPI from '../services/HierarchyAPI';

interface IBranchingLogicHierarchiesState {
	selectableHierarchies?: TFetchableEntity<ISelectOption[]>;
}

const initialState: IBranchingLogicHierarchiesState = {};

const fetchHierarchies = createAsyncThunk('branchingLogicHierarchies/fetchHierarchies', async (hrisId: string) => {
	return HierarchyAPI.getHrisHierarchies(hrisId);
});

const branchingLogicHierarchiesSlice = createSlice({
	name: 'branchingLogicHierarchies',
	initialState: initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchHierarchies.pending, (state) => {
				state.selectableHierarchies = { isLoading: true };
			})
			.addCase(fetchHierarchies.rejected, (state) => {
				state.selectableHierarchies = { isLoading: false, couldNotFetchData: true };
			})
			.addCase(fetchHierarchies.fulfilled, (state, action) => {
				const hierarchies: ISelectOption[] = action.payload.map((h) => ({ name: h.hierarchyId, displayText: h.name }));
				state.selectableHierarchies = hierarchies;
			});
	},
});

export { fetchHierarchies, type IBranchingLogicHierarchiesState, initialState };
export default branchingLogicHierarchiesSlice.reducer;
